// DetailField.tsx
import { Grid, Box } from "@mui/material";
import { StyledSpan, StyledText1 } from "../styles";

const boxStyle: React.CSSProperties = {
  border: "1.5px solid #d1d1e0",
  padding: "10px",
  marginBottom: "10px",
  borderRadius: "7px",
};

interface DetailFieldProps {
  label: string;
  value: string | number | null | undefined;
  xs?: number;
  format?: (value: any) => React.ReactNode;
  fallback?: React.ReactNode;
}

const DetailField: React.FC<DetailFieldProps> = ({
  label,
  value,
  xs = 3,
  format,
  fallback,
}) => {
  const hasValue = value !== null && value !== undefined && value !== "";

  if (!hasValue && fallback === undefined) {
    return null;
  }

  const displayValue = hasValue ? (format ? format(value) : value) : fallback;

  return (
    <Grid item xs={xs}>
      <Box style={boxStyle}>
        <StyledText1 variant="h6" color="primary" mb={1}>
          {label}
        </StyledText1>
        <StyledSpan>{displayValue}</StyledSpan>
      </Box>
    </Grid>
  );
};

export default DetailField;